import React from 'react'
import './components.css'

const Featurecard = ({ image, title }) => {

    // console.log(feature)

    return (
        <div>
            <div className='flex flex-col items-center h-[70px] bottom7px'>
                <img src={image} width={65} alt={title} />
            </div>
            <div>
                <p className='text-center txt-small brand-font'>{title}</p>
            </div>
        </div>
    )
}

export default Featurecard